import React, { useState, useEffect } from "react";
import api from "../../api/api";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  CircularProgress,
  Grid,
} from "@mui/material";
import Swal from "sweetalert2";
import MuiHeader from "../../components/MuiHeader";
import { ToastContainer, toast } from "react-toastify";

const Maintainance = () => {
  const [userType, setUserType] = useState("");
  const [userLevel, setUserLevel] = useState("");
  const [userDesignation, setUserDesignation] = useState("");
  const [userOrganization, setUserOrganization] = useState("");
  const [userOrgDesignation, setUserOrgDesignation] = useState("");

  const [data, setData] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [canceled, setCanceled] = useState(false);

  // New options based on backend schema
  const userTypeOptions = ["teacher", "crcc", "observer", "staff", "official"];
  const userLevelOptions = ["state", "district", "block", "cluster", "school"];
  const userDesignationOptions = [
    "teacher", "junior_teacher", "assistant_teacher", "senior_teacher", "head_master", "government",
    "ngo_partner", "deo", "beo", "crcc", "hm", "spd", "adeo", "abeo", "additional", "diet_principal",
    "abeo_cum_brcc", "joint_director", "diet_faculty", "deputy_direct", "pedagogy_coordinator",
    "assistant_director", "science_coordinator", "tribal_coordinator", "nipun_coordinator",
    "nipun_fellow", "planning_coordinator", "girls_education_coordinator", "ie_coordinator", "programer_mis"
  ];
  const userOrganizationOptions = [
    "akshara_foundation", "central_square_foundation", "language_and_learning_foundation",
    "learning_links_foundation", "piramal_foundation_for_education_leadership",
    "pratham_education_foundation", "unicef"
  ];
  const userOrgDesignationOptions = [
    "academic_manager", "associate_project_director", "block_academic_coordinator", "block_coordinator",
    "block_manager", "cfc", "consultant", "crp", "dpm_mle", "gandhi_fellow", "karuna_fellow", "mis_manager",
    "pm", "program_leader", "program_manager", "programme_associate", "project_associate", "project_lead",
    "project_manager", "resource_person", "sac", "senior_program_leader", "senior_project_lead",
    "senior_project_manager", "senior_specialist_fln", "sfm", "spm", "specialist_mle", "state_program_manager", "team_leader"
  ];

  // Mapping of old keys to new names (can be expanded based on schema)
  const keyMappings = {
    home: "Home",
    training: "Training",
    cotPreview: "COT Preview",
    mcmReflection: "MCM Reflection",
    venueScreen: "Venue Screen",
    mcmScreen: "MCM Screen",
    mcmLanding: "MCM Landing",
    morepage: "More Page",
    faq: "FAQ",
    manuals: "Manuals",
    helpCentre: "Help Centre",
    mediaManuals: "Media Manuals",
    mcmReflectionPreview: "MCM Reflection Preview",
    obsSpot: "Obs Spot",
    orf: "ORF",
    teacherList: "Teacher List",
    progress: "Progress",
    moreModulesTBA: "More Modules TBA",
    scheduler: "Scheduler",
    ppt: "PPT",
    reviewMeeting: "Review Meeting",
    brmForm: "BRM Form",
    MonitoringForm: "Monitoring Form",
    studentRegister: "Student Register",
    studentScanner: "Student Scanner",
    sikhayanaSopanaStatic: "Sikhayana Sopana Static",
    sikhyanaSopana: "Sikhyana Sopana",
    sikhyanaSopanaLanding: "Sikhyana Sopana Landing",
    sikhyanaSopanaPreview: "Sikhyana Sopana Preview",
    resources: "Resources",
    notification: "Notification",
    studentprogress: "Student Progress",
    questionUpload: "Question Upload",
    __v: "",
    userType: "",
    userLevel: "",
    userDesignation: "",
    userOrganization: "",
    userOrgDesignation: "",
  };

  useEffect(() => {
    if (userType && !canceled) {
      setLoading(true);
      fetchData();
    } else {
      setCanceled(false);
    }
  }, [userType, userLevel, userDesignation, userOrganization, userOrgDesignation, canceled]);

  const fetchData = async () => {
    try {
      const response = await api.get(`getMaintainanceStatus/${userType}`, {
        params: {
          userLevel: userLevel || undefined,
          userDesignation: userDesignation || undefined,
          userOrganization: userOrganization || undefined,
          userOrgDesignation: userOrgDesignation || undefined,
        },
      });
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response?.status === 500) {
        toast.error("Internal server error.");
      } else if (error.response?.status === 504) {
        toast.error("Server timeout. Please try again later.");
      } else if (error.response?.status === 400 || error.response?.status === 404) {
        // Clear data if not found
        setData({});
        toast.warn("Maintenance data not available for this combination.");
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateClick = () => {
    if (userType) {
      setEditMode(!editMode);
    } else {
      Swal.fire("Please select UserType", "", "warning");
    }
  };

  const handleValueChange = (key) => {
    const updatedData = { ...data };
    updatedData[key] = !updatedData[key];
    setData(updatedData);
  };

  const handleSaveClick = (e) => {
    Swal.fire({
      title: "Enter Password!",
      input: "text",
      inputPlaceholder: "Enter your password.",
      inputAttributes: {
        autocapitalize: "off",
        autocorrect: "off",
      },
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Submit",
      confirmButtonColor: "#3085d6",
      inputValidator: (value) => {
        if (!value) {
          return "Please enter the password!";
        } else if (value !== "tHINKZONEedu2016$#") {
          return "Password is incorrect!";
        }
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (result.value === "tHINKZONEedu2016$#") {
          const payload = {
            ...data,
            userType,
            userLevel: userLevel || undefined,
            userDesignation: userDesignation || undefined,
            userOrganization: userOrganization || undefined,
            userOrgDesignation: userOrgDesignation || undefined,
            userDetails: {
              userId: "admin@thinkzone.in",
              userName: "Admin",
            },
            password: "tHINKZONEedu2016$#",
          };
          try {
            await api.patch(`/updateMaintainanceStatus`, payload);
            setEditMode(false);
            Swal.fire("Success!", "Successfully updated.", "success");
            fetchData();
          } catch (error) {
            console.error("Error updating data:", error);
            if (error.response?.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response?.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              toast.error(
                error.response?.data?.msg || "An unexpected error occurred."
              );
            }
          }
        }
      }
    });
  };

  const handleCancelClick = () => {
    setCanceled(true);
    setEditMode(false);
  };

  return (
    <>
      <div>
        <MuiHeader header="Maintainance page" />
        <Grid container spacing={2} style={{ marginTop: "20px", padding: "0 20px" }}>
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel id="usertype-label">User Type *</InputLabel>
              <Select
                labelId="usertype-label"
                value={userType}
                onChange={(e) => setUserType(e.target.value)}
                label="User Type *"
              >
                <MenuItem value="">None</MenuItem>
                {userTypeOptions.map((opt) => (
                  <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel id="userlevel-label">User Level</InputLabel>
              <Select
                labelId="userlevel-label"
                value={userLevel}
                onChange={(e) => setUserLevel(e.target.value)}
                label="User Level"
              >
                <MenuItem value="">None</MenuItem>
                {userLevelOptions.map((opt) => (
                  <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel id="userdesig-label">Designation</InputLabel>
              <Select
                labelId="userdesig-label"
                value={userDesignation}
                onChange={(e) => setUserDesignation(e.target.value)}
                label="Designation"
              >
                <MenuItem value="">None</MenuItem>
                {userDesignationOptions.map((opt) => (
                  <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel id="userorg-label">Organization</InputLabel>
              <Select
                labelId="userorg-label"
                value={userOrganization}
                onChange={(e) => setUserOrganization(e.target.value)}
                label="Organization"
              >
                <MenuItem value="">None</MenuItem>
                {userOrganizationOptions.map((opt) => (
                  <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel id="userorgdesig-label">Org Designation</InputLabel>
              <Select
                labelId="userorgdesig-label"
                value={userOrgDesignation}
                onChange={(e) => setUserOrgDesignation(e.target.value)}
                label="Org Designation"
              >
                <MenuItem value="">None</MenuItem>
                {userOrgDesignationOptions.map((opt) => (
                  <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <div style={{ marginTop: "20px", marginLeft: "20px" }}>
          {editMode ? (
            <>
              <Button onClick={handleSaveClick} variant="contained" color="primary" style={{ marginRight: "10px" }}>
                Save
              </Button>
              <Button onClick={handleCancelClick} variant="contained" color="error">
                Cancel
              </Button>
            </>
          ) : (
            userType && (
              <Button onClick={handleUpdateClick} variant="contained" color="primary">
                Edit
              </Button>
            )
          )}
        </div>

        {userType && (
          <div style={{ padding: "0 20px" }}>
            {loading ? (
              <CircularProgress style={{ marginTop: "20px" }} />
            ) : Object.keys(data).length > 0 ? (
              <Table style={{ marginTop: "20px", maxWidth: "600px", width: "100%" }}>
                <TableHead>
                  <TableRow style={{ backgroundColor: "#f0f0f0" }}>
                    <TableCell style={{ fontWeight: "bold" }}>Module Name</TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.keys(data).map((key, index) => {
                    // Skip internal fields
                    if (key === "userType" || key === "userLevel" || key === "userDesignation" || key === "userOrganization" || key === "userOrgDesignation" || key === "userCode" || key === "_id" || key === "__v" || key === "questionUpload") return null;

                    return (
                      <TableRow key={index}>
                        <TableCell>{keyMappings[key] || key}</TableCell>
                        <TableCell>
                          {editMode ? (
                            <Button
                              variant="contained"
                              color={data[key] ? "secondary" : "primary"}
                              onClick={() => handleValueChange(key)}
                              style={{ textTransform: "none" }}
                            >
                              {data[key] ? "OFF" : "ON"}
                            </Button>
                          ) : data[key] ? (
                            "ON"
                          ) : (
                            "OFF"
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            ) : (
              <p style={{ marginTop: "20px" }}>No data found for this combination.</p>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Maintainance;
